import * as React from 'react';
// eslint-disable-next-line eslint-custom-plugin/no-next-router
import NextLink from 'next/link';
import type { LinkT as RagnarLinkT } from '@mentimeter/ragnar-ui/link';

export interface GenericLinkProps extends Pick<RagnarLinkT, 'children'> {
  href?: string | undefined;
  prefetch?: boolean | null;
}

export const EnablePrefetchLink =
  <T,>(Component: React.ComponentType<Omit<T, 'href' | 'prefetch'>>) =>
  ({ href, prefetch = null, ...props }: T & GenericLinkProps) => {
    if (!href) return <Component {...props} />;

    return (
      <NextLink href={href} prefetch={prefetch} passHref legacyBehavior>
        <Component {...props} />
      </NextLink>
    );
  };
